<div class="modal-header">
  <h4 class="modal-title pull-left">Stage Assignment</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <crm-alert #alert></crm-alert>
  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">Next Stage</label>
      <input-search [preset]="stagesList" placeholder="Select New Stage" [regular]="true" [inputValue]="nextStage" [highligtValue]="nextStageId"
                    (valueChange)="stageSelected($event)" [disabled]="disabledInput"></input-search>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">Assign To <span *ngIf="auto" class="auto"> (Assigned automatically)</span></label>


      <ng-container *ngIf="isSubmitter(); else otherStages">
         <input-search style="width: 100%;" [provider]="userProvider"
           [position]="'REPORT_SUBMITTER'" placeholder="Select or Type to Search for User to Assign Stage"
            [itemsHeader]="'Search Results'" [disabled]="assignToMe"
           (valueChange)="assignToSelected($event)"></input-search>


      </ng-container>

      <ng-template #otherStages>
        <div *ngIf="!isChangedAssignee" class="input-wrapper" style="display: flex; align-items: center; justify-content: space-between;">

         <input-search style="width: 100%;" [preset]="userTypes" [provider]="userProvider" [disabled]="auto"
           [inputValue]="assignToInputValue" placeholder="Select or Type to Search for User to Assign Stage" [presetHeader]="'Report Roles'"
           [itemsHeader]="'Search Results'" (valueChange)="assignToSelected($event)"
           [disabled]="assignToMe"></input-search>

            <button *ngIf="auto" (click)="isChangedAssignee = true;" tooltip="Change Assignee" type="button"
              class="close" aria-label="Close" style="padding-left: 5px; padding-right: 5px; outline: 0;"
              [disabled]="assignToMe">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
        </div>

        <div *ngIf="isChangedAssignee" class="input-wrapper" style="display: flex; align-items: center; justify-content: space-between;">

          <input-search style="width: 100%;" [provider]="userProvider" [inputValue]="selectedAssignee" [position]="stageRequest.ASSIGNEE_TYPE_USER"
            placeholder="Select or Type to Search for User to Assign Stage"
            [itemsHeader]="'Search Results'" (valueChange)="onSelectedAssignee($event)"></input-search>

          <button (click)="isChangedAssignee = false;" tooltip="Change Assignee" type="button"
            class="close" aria-label="Close"
            style="padding-left: 5px; padding-right: 5px; outline: 0;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </ng-template>
    </div>

    <div class="col-sm-12" *ngIf="!assignToInputValue">
       <div class="checkbox-item">
         <input class="checkbox-custom" type='checkbox' name="ASSIGN_TO_ME" id="ASSIGN_TO_ME" [(ngModel)]="assignToMe"
         (ngModelChange)="onAssignToMeValueChange($event)"/>
         <label class="checkbox-custom-label" for="ASSIGN_TO_ME">Assign to me</label>
       </div>
    </div>
  </div>

  <div class="row" *ngIf="!auto && stageRequest.ID && stageRequest.reportUserType">
    <div class="col-sm-12">
      <fa name="fa fa-exclamation-triangle" style="color: orange; margin-right: 5px;"></fa>
       <span style="color: #5881af">No <b>{{stageRequest.reportUserType | reportUserType}}</b> from Reliant Party matches rule set for selected Stage.
         Please pick Assignee manually.</span>
    </div>
  </div>

  <div class="row" *ngIf="isSubmitter();">
    <div class="col-sm-12">
      <label class="rbv-label">File Location</label>
      <input type="text" class="form-control rounded-0" name="FILE_LOCATION" [(ngModel)]="stageRequest.FILE_LOCATION">
    </div>
  </div>

  <div class="row" *ngIf="isOverDue()">
    <div class="col-sm-12">
      <label>Delay</label>
      <input-search [preset]="delays" placeholder="Select Delay" [regular]="true"
        (valueChange)="onDelaySelected($event)"></input-search>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">Notes</label>
      <textarea class="form-control rounded-0" rows="3" name="NOTES" [(ngModel)]="stageRequest.NOTES"></textarea>
    </div>
  </div>

  <div class="row" *ngIf="isSubmitted()">
    <div class="col-sm-12">
       <label class="rbv-label">Rate Your File: </label>
       <custom-rating (valueChange)="onRatingSet($event)"></custom-rating>
    </div>
  </div>
  <div class="row" *ngIf="isSubmitted()">
    <div class="col-sm-12">
      <label class="rbv-label">Errors</label>
      <input-search [preset]="errors" placeholder="Select" [regular]="true" 
                    (valueChange)="onErrorSelected($event)" ></input-search>
    </div>
  </div>
  <div class="row" *ngIf="isSubmitted()">
    <div class="col-sm-12">
      <label class="rbv-label">Value Assessment</label>
      <div style="display: flex; gap: 20px; margin-top: 10px;">
        <div class="radio-item">
          <input type="radio" class="radio-custom" name="valueAssessment" id="valueAssessmentValue" value="VALUE" 
                 [(ngModel)]="stageRequest.VALUE_ASSESSMENT" (ngModelChange)="onValueAssessmentChange($event)">
          <label class="radio-custom-label" for="valueAssessmentValue">Value</label>
        </div>
        <div class="radio-item">
          <input type="radio" class="radio-custom" name="valueAssessment" id="valueAssessmentNotValue" value="NOT_VALUE" 
                 [(ngModel)]="stageRequest.VALUE_ASSESSMENT" (ngModelChange)="onValueAssessmentChange($event)">
          <label class="radio-custom-label" for="valueAssessmentNotValue">Not Value</label>
        </div>
        <div class="radio-item">
          <input type="radio" class="radio-custom" name="valueAssessment" id="valueAssessmentNA" value="N/A" 
                 [(ngModel)]="stageRequest.VALUE_ASSESSMENT" (ngModelChange)="onValueAssessmentChange($event)">
          <label class="radio-custom-label" for="valueAssessmentNA">N/A</label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="footer-wrapper">
    <div class="checkbox-item">
      <input class="checkbox-custom" type='checkbox' name="notifyClient" id="notifyClient" [(ngModel)]="stageRequest.NOTIFY_CLIENT"/>
      <label class="checkbox-custom-label" for="notifyClient">
        Send Notification to Client
      </label>
    </div>

    <div class="actions">
      <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
      <button class="btn btn-rbv warning" [disabled]="!validateInput()" (click)="onConfirm()">Assign</button>
    </div>
  </div>
</div>
